// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"953":"0c343536","982":"184b441c"}[chunkId] + ".chunk.js";
};